export const toSelectOptions = records =>
  records.map(({ id, name }) => ({ key: id, value: id, text: name }));
